module.exports = __webpack_public_path__ + "img/1.7ea43162.jpg";